import React, { useMemo } from 'react';
import { Section, SectionTitle } from '@repo/components/containers';
import { useSelector } from 'react-redux';
import { selectContactTimeline } from '@repo/redux/reducers/data/timeline';
import { SidebarTimelineInteraction } from '@repo/components/timeline';
import Contact from '@repo/utils/models/Contact';
import { TimelineItem } from '@repo/utils/models/Timeline';

export default function SidebarTimeline({ contact }: { contact: Contact }) {
  const timeline = useSelector(selectContactTimeline(contact.id, true));
  const timelineItems = useMemo<TimelineItem[]>(() => {
    return timeline.items.valueSeq().toArray().slice(0, 4);
  }, [timeline]);

  if (timelineItems.length === 0) {
    return null;
  }

  return (
    <Section>
      <SectionTitle underline>Timeline</SectionTitle>
      <div>
        {timelineItems.map((item, idx, timeline) => {
          const isLast = idx === timeline.length - 1;
          return (
            <SidebarTimelineInteraction
              key={item.stableID}
              contact={contact}
              timelineItem={item}
              isLast={isLast}
            />
          );
        })}
      </div>
    </Section>
  );
}
